import {pageInfo} from '../api';
import {plant} from '../../../../../api'

const hikFaceAuth = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => {
        // 下发状态颜色
        if (item.sendMqttStatusDesc === '下发失败') {
          item.sendMqttStatusDescColor = '#F56C6C';
        } else if (item.sendMqttStatusDesc === '已下发') {
          item.sendMqttStatusDescColor = '#67C23A';
        } else {
          item.sendMqttStatusDescColor = '#909399';
        }
        // 确认状态颜色
        if (item.confirmStatusDesc === '失败') {
          item.confirmStatusDescColor = '#F56C6C';
        } else if (item.confirmStatusDesc === '成功') {
          item.confirmStatusDescColor = '#67C23A';
        } else {
          item.confirmStatusDescColor = '#909399';
        }
        return {...item, btns: [true]};
      });
    },
    PLANT(state, data) {
      state.plantObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    }
  }
}
export default hikFaceAuth



// WEBPACK FOOTER //
// ./src/page/int/face/hikFaceAuth/store/hikFaceAuth.store.js